import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import type { ISubscription } from "./types";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import CreateButton from "../../components/common/CreateButton";
import RowActions from "../../components/table/RowActions";

export interface ISubscriptionRecord extends Pick<ISubscription,
    '_id'
    | 'durationInDays'
    | 'isActive'
    | 'isFeatured'
    | 'order'
    | 'price'
    | 'priceText'
    | 'title'
    | 'createdAt'
    | 'purchasedCount'
    | 'applePriceText'
    | 'appleSKU'
    | 'code'
    | 'googlePriceText'
    | 'googleSKU'
> {
    actions: unknown;
}

const SubscriptionList = () => {

    const { handleInteraction, records, deleteRecord, paginationState } = useListPage({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    })

    const columns: Column<ISubscriptionRecord>[] =  [
        {
            Header: 'Код',
            accessor: 'code',
        },
        {
            Header: 'Нэр',
            accessor: 'title',
        },
        {
            Header: 'Үнэ /текст/',
            accessor: 'priceText'
        },
        {
            Header: 'Apple үнэ /текст/',
            accessor: 'applePriceText'
        },
        {
            Header: 'Apple SKU',
            accessor: 'appleSKU'
        },
        {
            Header: 'Google үнэ /текст/',
            accessor: 'googlePriceText'
        },
        {
            Header: 'Google SKU',
            accessor: 'googleSKU'
        },
        {
            Header: 'Хугацаа /өдөр/',
            accessor: 'durationInDays',
        },
        {
            Header: 'Худалдан авсан тоо',
            accessor: 'purchasedCount',
        },
        {
            Header: 'Дараалал',
            accessor: 'order',
        },
        {
            Header: 'Онцолсон эсэх',
            accessor: 'isFeatured',
            Cell: ({ value }) => {
                return <TableIndicator active={value} color={value ? 'orange' : undefined}/>;
            },
            width: 1
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Үүссэн огноо',
            accessor: 'createdAt',
            Cell: ({ value }) => {
                return (
                    <div>
                        {dayjs(value).format('YYYY.MM.DD HH:mm')}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} deleteRecord={deleteRecord} clientRoute={CLIENT_ROUTE}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default SubscriptionList;